export const examAdminSystemSettings = {
  pageTitle: "系统管理",
  pageSubtitle: "站点、AI 接入、安全策略与审计配置入口。",
  infoBanner: "系统设置已接入数据库持久化，变更会写入审计日志。",
  currentConfig: "当前系统配置",
  platformName: "平台名称",
  candidatePortalBaseUrl: "考生登录地址",
  environment: "运行环境",
  databaseBackend: "数据库后端",
  judgeBackend: "判题后端",
  environmentBackend: "环境后端",
  aiBackend: "AI 后端",
  assetStorageBackend: "资源存储后端",
  capabilityMatrix: "平台能力矩阵",
  roles: "角色",
  questionTypes: "题目类型",
  paperTypes: "试卷类型",
  judgeLanguages: "判题语言",
  environmentQuestionTypes: "环境支持题型",
  siteSettings: "站点设置",
  saveSiteSettings: "保存站点设置",
  uploadLogo: "上传站点标识",
  uploadFavicon: "上传站点图标",
  logoUploaded: "站点标识上传成功",
  faviconUploaded: "站点图标上传成功",
  logoUploadFailed: "站点标识上传失败",
  faviconUploadFailed: "站点图标上传失败",
  logoUrl: "站点标识地址",
  logoAssetId: "站点标识资源 ID",
  faviconUrl: "站点图标地址",
  faviconAssetId: "站点图标资源 ID",
  maintenanceMode: "维护模式",
  aiSettings: "AI 接入设置",
  saveAiSettings: "保存 AI 设置",
  endpoint: "接口地址",
  defaultModel: "默认模型",
  apiKey: "接口密钥（当前：{value}）",
  securitySettings: "安全策略",
  saveSecuritySettings: "保存安全策略",
  requirePasswordChangeOnFirstLogin: "首次登录必须修改密码",
  maxFailedLoginAttempts: "密码错误锁定阈值",
  lockMinutes: "锁定时长（分钟）",
  captchaEnabled: "启用登录验证码",
  captchaFailThreshold: "连续失败触发阈值",
  candidateAllowIpRanges: "考生允许登录 IP 段（每行一个，支持 CIDR/单IP）",
  candidateDenyIpRanges: "考生禁止登录 IP 段（每行一个，支持 CIDR/单IP）",
  adminAllowIpRanges: "管理端允许登录 IP 段（每行一个，支持 CIDR/单IP）",
  adminDenyIpRanges: "管理端禁止登录 IP 段（每行一个，支持 CIDR/单IP）",
  candidateAllowMultiLogin: "考生允许多点登录",
  staffAllowMultiLogin: "考务人员允许多点登录",
  judgeSettings: "判题镜像配置",
  judgeSettingsHint:
    "用于配置 exam-judge 的 Python / Node / Go 运行镜像标识。可选择“即时生效”（按请求下发）或“重启生效”（仅保存配置）。",
  saveJudgeSettings: "保存判题配置",
  judgeImagePython: "Python 运行镜像标识",
  judgeImageNode: "Node 运行镜像标识",
  judgeImageGo: "Go 运行镜像标识",
  judgeApplyMode: "生效策略",
  judgeApplyModeImmediate: "即时生效",
  judgeApplyModeRestart: "重启生效",
  containerHostPortAssignMode: "容器宿主端口分配模式",
  containerHostPortAssignModeRandom: "随机分配",
  containerHostPortAssignModeSequential: "顺序分配",
  containerHostPortRangeHint: "仅在该端口区间内分配宿主机端口（用于实操题/夺旗题体验容器）。",
  containerHostPortRangeStart: "宿主端口起始值",
  containerHostPortRangeEnd: "宿主端口结束值",
  containerHostPortRangeInvalid: "结束端口必须大于或等于起始端口",
  storageSettings: "对象存储配置",
  saveStorageSettings: "保存对象存储配置",
  storageBackend: "存储后端",
  storageBackendLocal: "本地（local）",
  storageBackendOSS: "阿里云 OSS",
  integrationSettings: "平台集成配置",
  saveIntegrationSettings: "保存平台集成配置",
  integrationHint: "优先级：系统设置 > 环境变量回退 > 默认值。留空即可继续使用回退值。",
  integrationEffectiveValue: "当前生效值：{value}",
  integrationSource: "来源：{source}",
  integrationFallbackHint: "如需直接接管当前回退值，可点击“重置”回填到输入框。",
  integrationReset: "重置",
  ossEndpoint: "OSS Endpoint",
  ossRegion: "OSS Region",
  ossBucket: "Bucket",
  ossPrefix: "对象前缀（可选）",
  ossUseHttps: "使用 HTTPS",
  ossAccessKeyId: "AccessKey ID（当前：{value}）",
  ossAccessKeySecret: "AccessKey Secret（当前：{value}）",
  siteSaved: "站点设置已保存",
  aiSaved: "AI 接入设置已保存",
  securitySaved: "安全策略已保存",
  judgeSaved: "判题镜像配置已保存",
  storageSaved: "对象存储配置已保存",
};
